module.exports = __webpack_public_path__ + "static/media/OurProduct-TanCircle.4c6a8ca3.svg";